import { useEffect } from 'react';
import { useMessagingStore } from './use-messaging-store';

export const useShowNoConversationSelected = () => {
    const {
        isBookmarksView,
        selectedConversationFilter,
        selectedConversationKey,
        selectedConversationMessageListLength,
        setSelectedConversationKey,
    } = useMessagingStore();

    // this useEffect handles showing the 'no conversation selected screen' when in non-bookmark view
    useEffect(() => {
        if (
            !isBookmarksView &&
            selectedConversationFilter !== undefined &&
            selectedConversationKey?.participantIdentity !== undefined
        ) {
            if (selectedConversationKey.isBookmarkedConversation) {
                setSelectedConversationKey(undefined);
            } else if (selectedConversationFilter.filterType === 'ALL_ACTIVE') {
                return;
            } else if (
                selectedConversationFilter.filterParticipant?.id !==
                selectedConversationKey.participantIdentity.id
            ) {
                setSelectedConversationKey(undefined);
            }
        }
    }, [
        isBookmarksView,
        selectedConversationFilter,
        selectedConversationKey,
        setSelectedConversationKey,
    ]);

    // this useEffect handles showing the 'no conversation selected screen' when in the bookmark view
    useEffect(() => {
        if (
            isBookmarksView &&
            selectedConversationKey?.participantIdentity !== undefined &&
            selectedConversationMessageListLength !== undefined
        ) {
            if (selectedConversationMessageListLength === 0) {
                setSelectedConversationKey(undefined);
            }
        }
    }, [
        isBookmarksView,
        selectedConversationKey,
        setSelectedConversationKey,
        selectedConversationMessageListLength,
    ]);
};
